import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";
import React from "react";

const ButtonTableBulkDelete = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "delete",
    className: `w-[60px] h-[35px] flex justify-center items-center rounded-[4px] ${props.className}`,
  };
  return (
    <Button {...tmpProps}>
      削除
    </Button>
  );
};

export default ButtonTableBulkDelete;
